module.exports = __webpack_public_path__ + "static/media/etravosLogin.976d7afb.png";